<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="buffetPro">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Buffets pour les professionnels
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#6f5d53;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <p>
                                            Le buffet est la prestation phare de notre activité de <b>traiteur pour les
                                            professionnels</b>. Il faut dire que cette formule cumule les avantages !
                                        </p>
                                        <h2 class="display-5 bottomH2">Le buffet, un vrai repas à table </h2>
                                        <p>
                                            Avec le buffet, vos convives profitent d’un authentique moment de plaisir à
                                            table. Le <b>buffet, chaud ou froid</b>, se compose d’une succession de
                                            plats, comme un repas assis « classique ».
                                        </p>
                                        <p>
                                            Toutes nos formules comprennent au moins un assortiment de salades et de
                                            crudités, des charcuteries et des viandes froides, ainsi qu’une sélection de
                                            fromages et de desserts. Nos <b>buffets premium</b> incluent en plus des
                                            préparations chaudes ou froides de poissons, comme du saumon.
                                        </p>
                                        <h2 class="display-5 bottomH2">Liberté et variété</h2>
                                        <p>
                                            L’autre avantage du buffet, c’est que vos convives vont et viennent très
                                            librement, en parallèle d’un événement professionnel comme un salon ou un
                                            séminaire par exemple.
                                        </p>
                                        <p>
                                            La grande diversité des plats proposés permet à chacun d’y trouver son
                                            bonheur, en fonction de ses goûts et de son appétit. Vos convives mangent à
                                            leur rythme, en toute autonomie.
                                        </p>
                                        <h2 class="display-5 bottomH2">Une prestation complète</h2>
                                        <p>
                                            Si vous choisissez un <b>buffet chaud</b>, les plats sont conservés à
                                            température grâce à des bains-marie. Nous nous assurons de la disponibilité
                                            des produits tout au long du repas.
                                        </p>
                                        <p>
                                            Si vous le souhaitez, Croustillance peut aussi régler pour vous les
                                            questions liées au <b>mobilier</b>, au <b>nappage</b> et au <b>dressage</b>.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/buffets-professionnels/tartes-echalote.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Les formules buffets</h3>
                                        <p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-froid-CLASSIQUE.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet CLASSIQUE</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/buffet-froid-GOURMET.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le buffet GOURMET</span>
                                            </a>
                                        </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4" style="background:#434a5c;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Une solution qui a fait ses preuves</h3>
                                        <p>
                                            Facile à organiser, à installer et désinstaller, le buffet reste la formule
                                            préférée des professionnels.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/buffets-professionnels/buffet-charcuterie.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/buffets-professionnels/buffet-charcuterie.jpg"
                                         alt="Buffet de charcuterie"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/buffets-professionnels/buffet-charcuterie.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#aaa183">
                            <div class="item media text-white alignLeft">

                                <div class="media-body align-top">
                                    <div class="desc">

                                        <p style="font-size: 35px; font-family: Nunito, sans-serif; font-weight: bold;">
                                            Vos convives peuvent papillonner de plat en plat, changer d’interlocuteur à
                                            leur guise… Le buffet, c’est la liberté.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/buffets-professionnels/buffet-vegetarien.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/buffets-professionnels/buffet-vegetarien.jpg"
                                         alt="Buffet vegetarien"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/buffets-professionnels/buffet-vegetarien.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4" style="background:#eb526e;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Toujours plus</h3>
                                        <p>
                                            Comme pour toutes nos autres prestations, nous mettons aussi à votre
                                            disposition notre personnel qualifié et notre mobilier.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/buffets-professionnels/buffet-sandwich.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/buffets-professionnels/buffet-sandwich.jpg"
                                         alt="Buffet pour entreprises dans les Vosges"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/buffets-professionnels/buffet-sandwich.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <footer-page></footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'buffetPro',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = " Nos buffets, froids ou chauds, permettent de profiter en toute liberté d'un vrai moment de plaisir à table, en parallèle d’un événement professionnel.";
            document.title = "Buffets pour les professionnels | Traiteur Croustillance";
        }
    }
</script>

<style>
    #buffetPro {
        background: url('/img/buffets-professionnels/petits-fours-cocktail.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>